import React from 'react';
import { Divider, Paper, Typography } from '@mui/material';
import { css } from '@emotion/react';
import { Color, FONT_FAMILY } from '../../constants';
const useStyles = () => ({
    root: css({
      width: '100%',
      height: 'fit-content',
    }),
    titleContainer: css({
      width: '100%',
      height: 'fit-content',
    }),
    iconContainer: css({
      fontSize: 22,
      marginRight: 12,
      '& svg': {
        color: '#616161',
      },
    }),
  });
export const Tableau = props => {
    const classes = useStyles();
    const { title, header, icon, data, children, showPaper } = props;
    return (React.createElement("div", { className: classes.root },
        React.createElement(Paper, { elevation: showPaper ? 2 : 0, style: {
                padding: showPaper ? 16 : 0,
                borderRadius: 8
            } },
            title && (React.createElement("div", { className: classes.titleContainer },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    icon && (React.createElement("div", { className: classes.iconContainer }, icon)),
                    React.createElement("div", { style: { marginBottom: 6 } },
                        React.createElement(Typography, { style: { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, color: Color.neutral[500], fontSize: 10 } }, `${header}`),
                        React.createElement(Typography, { style: { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, color: Color.neutral[900], fontSize: 15, marginTop: -2 } }, `${title}`))))),
            data.map((row, index) => (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', width: '100%', backgroundColor: index % 2 === 0 ? Color.primary[100] : 'transparent' } },
                    React.createElement("div", { style: { width: '50%', padding: 6, paddingLeft: 12 } },
                        React.createElement(Typography, { style: { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, fontSize: 12, color: '#424242' } }, row.label)),
                    React.createElement("div", { style: { width: '50%', padding: 6 } },
                        React.createElement(Typography, { style: { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, fontSize: 12, color: '#424242' } }, row.value))),
                row.element && row.element,
                row.divider && (React.createElement("div", { style: { marginTop: 10, marginBottom: 10 } },
                    React.createElement(Divider, null)))))),
            children && (React.createElement("div", { style: { paddingTop: 10 } }, children)))));
};
Tableau.defaultProps = {
    showPaper: true
};
